(() => {
  const roots = document.querySelectorAll('[data-rcc-root]');
  if (!roots.length) return;

  const DEFAULT_TRANSLATIONS = {
    nl: {
      locale: 'nl-NL',

      loadErrorCount: 'Compatibiliteitsdata kon niet worden geladen.',
      loadErrorTitle: 'De compatibiliteitsdata is tijdelijk niet beschikbaar',
      loadErrorText: 'Probeer de pagina opnieuw te laden of neem contact op met Rebor Solar.',

      batteryModeTitle: 'Welke batterij heb je?',
      batteryModeDescription: 'Kies je batterij om alle officieel bevestigde compatibele omvormers te bekijken.',
      batteryQueryLabel: 'Zoek batterij op productnaam of modelnummer',
      batteryQueryPlaceholder: 'Bijv. HVM+, US5000 of DL5.0C Pro',
      inverterAlpha: 'Omvormer A-Z',

      inverterModeTitle: 'Welke omvormer heb je?',
      inverterModeDescription: 'Kies je omvormer om alle officieel bevestigde compatibele batterijen te bekijken.',
      inverterQueryLabel: 'Zoek omvormer op productnaam of modelnummer',
      inverterQueryPlaceholder: 'Bijv. S6-EH3P10K-H of GW5000-ES-20',
      batteryAlpha: 'Batterij A-Z',

      allBrands: 'Alle merken',
      allModels: 'Alle modellen',
      allModelsBrand: 'Alle modellen van dit merk',

      promptBatteryCount: 'Kies een batterij om passende omvormers te bekijken',
      promptInverterCount: 'Kies een omvormer om passende batterijen te bekijken',
      promptBatteryTitle: 'Kies een batterij om te beginnen',
      promptBatteryText: 'Selecteer een batterijmerk of model, gebruik LV/HV of zoek direct op modelnummer.',
      promptInverterTitle: 'Kies een omvormer om te beginnen',
      promptInverterText: 'Selecteer een omvormermerk of model of zoek direct op modelnummer.',

      confirmedCombination: 'officieel bevestigde combinatie',
      confirmedCombinations: 'officieel bevestigde combinaties',
      found: 'gevonden',
      loadMore: 'Meer resultaten tonen',
      remaining: 'resterend',

      doubleConfirmed: 'Dubbel officieel bevestigd',
      inverterManufacturerConfirmed: 'Officieel bevestigd door omvormerfabrikant',
      batteryManufacturerConfirmed: 'Officieel bevestigd door batterijfabrikant',
      singleConfirmed: 'Officieel bevestigd door één fabrikant',
      doubleConfirmedDescription: 'Bevestigd door beide fabrikanten.',
      inverterManufacturerConfirmedDescription: 'Expliciet bevestigd door de omvormerfabrikant.',
      batteryManufacturerConfirmedDescription: 'Expliciet bevestigd door de batterijfabrikant.',
      singleConfirmedDescription: 'Expliciet bevestigd in minimaal één officiële fabrikantbron.',

      min: 'Min.',
      max: 'max.',
      modules: 'modules',
      notAvailable: 'n.v.t.',
      noModuleLimit: 'Geen modulegrens vermeld in deze bron.',
      noAdditionalCondition: 'Geen aanvullende voorwaarde vermeld in deze bron.',

      viewBattery: 'Bekijk batterij',
      viewInverter: 'Bekijk omvormer',
      technicalConditions: 'Technische voorwaarden en bronnen',
      firmware: 'Firmware',
      moduleConfiguration: 'Moduleconfiguratie',
      parallelOperation: 'Parallelbedrijf',
      accessories: 'Accessoires',
      communication: 'Communicatie:',
      marketCondition: 'Markt-/toepassingsvoorwaarde:',
      officialSource: 'Officiële bron:',
      sourceFallback: 'Bron geregistreerd in Rebor masterdataset.',
      checked: 'Gecontroleerd:',

      batteryBrand: 'Batterijmerk',
      batteryModel: 'Batterijmodel',
      inverterBrand: 'Omvormermerk',
      inverterModel: 'Omvormermodel',
      voltage: 'Spanning',
      searchTerm: 'Zoekterm',
      removeFilter: 'verwijderen'
    },

    en: {
      locale: 'en-GB',

      loadErrorCount: 'Compatibility data could not be loaded.',
      loadErrorTitle: 'The compatibility data is temporarily unavailable',
      loadErrorText: 'Please reload the page or contact Rebor Solar.',

      batteryModeTitle: 'Which battery do you have?',
      batteryModeDescription: 'Select your battery to view all officially confirmed compatible inverters.',
      batteryQueryLabel: 'Search for a battery by product name or model number',
      batteryQueryPlaceholder: 'E.g. HVM+, US5000 or DL5.0C Pro',
      inverterAlpha: 'Inverter A-Z',

      inverterModeTitle: 'Which inverter do you have?',
      inverterModeDescription: 'Select your inverter to view all officially confirmed compatible batteries.',
      inverterQueryLabel: 'Search for an inverter by product name or model number',
      inverterQueryPlaceholder: 'E.g. S6-EH3P10K-H or GW5000-ES-20',
      batteryAlpha: 'Battery A-Z',

      allBrands: 'All brands',
      allModels: 'All models',
      allModelsBrand: 'All models from this brand',

      promptBatteryCount: 'Select a battery to view compatible inverters',
      promptInverterCount: 'Select an inverter to view compatible batteries',
      promptBatteryTitle: 'Select a battery to get started',
      promptBatteryText: 'Select a battery brand or model, use LV/HV or search directly by model number.',
      promptInverterTitle: 'Select an inverter to get started',
      promptInverterText: 'Select an inverter brand or model or search directly by model number.',

      confirmedCombination: 'officially confirmed combination',
      confirmedCombinations: 'officially confirmed combinations',
      found: 'found',
      loadMore: 'Show more results',
      remaining: 'remaining',

      doubleConfirmed: 'Officially confirmed by both manufacturers',
      inverterManufacturerConfirmed: 'Officially confirmed by inverter manufacturer',
      batteryManufacturerConfirmed: 'Officially confirmed by battery manufacturer',
      singleConfirmed: 'Officially confirmed by one manufacturer',
      doubleConfirmedDescription: 'Confirmed by both manufacturers.',
      inverterManufacturerConfirmedDescription: 'Explicitly confirmed by the inverter manufacturer.',
      batteryManufacturerConfirmedDescription: 'Explicitly confirmed by the battery manufacturer.',
      singleConfirmedDescription: 'Explicitly confirmed in at least one official manufacturer source.',

      min: 'Min.',
      max: 'max.',
      modules: 'modules',
      notAvailable: 'n/a',
      noModuleLimit: 'No module limit is specified in this source.',
      noAdditionalCondition: 'No additional condition is specified in this source.',

      viewBattery: 'View battery',
      viewInverter: 'View inverter',
      technicalConditions: 'Technical conditions and sources',
      firmware: 'Firmware',
      moduleConfiguration: 'Module configuration',
      parallelOperation: 'Parallel operation',
      accessories: 'Accessories',
      communication: 'Communication:',
      marketCondition: 'Market/application condition:',
      officialSource: 'Official source:',
      sourceFallback: 'Source registered in the Rebor master dataset.',
      checked: 'Checked:',

      batteryBrand: 'Battery brand',
      batteryModel: 'Battery model',
      inverterBrand: 'Inverter brand',
      inverterModel: 'Inverter model',
      voltage: 'Voltage',
      searchTerm: 'Search term',
      removeFilter: 'remove'
    },

    de: {
      locale: 'de-DE',

      loadErrorCount: 'Kompatibilitätsdaten konnten nicht geladen werden.',
      loadErrorTitle: 'Die Kompatibilitätsdaten sind vorübergehend nicht verfügbar',
      loadErrorText: 'Bitte laden Sie die Seite erneut oder kontaktieren Sie Rebor Solar.',

      batteryModeTitle: 'Welche Batterie haben Sie?',
      batteryModeDescription: 'Wählen Sie Ihre Batterie aus, um alle offiziell bestätigten kompatiblen Wechselrichter anzuzeigen.',
      batteryQueryLabel: 'Batterie nach Produktname oder Modellnummer suchen',
      batteryQueryPlaceholder: 'Z. B. HVM+, US5000 oder DL5.0C Pro',
      inverterAlpha: 'Wechselrichter A-Z',

      inverterModeTitle: 'Welchen Wechselrichter haben Sie?',
      inverterModeDescription: 'Wählen Sie Ihren Wechselrichter aus, um alle offiziell bestätigten kompatiblen Batterien anzuzeigen.',
      inverterQueryLabel: 'Wechselrichter nach Produktname oder Modellnummer suchen',
      inverterQueryPlaceholder: 'Z. B. S6-EH3P10K-H oder GW5000-ES-20',
      batteryAlpha: 'Batterie A-Z',

      allBrands: 'Alle Marken',
      allModels: 'Alle Modelle',
      allModelsBrand: 'Alle Modelle dieser Marke',

      promptBatteryCount: 'Wählen Sie eine Batterie aus, um passende Wechselrichter anzuzeigen',
      promptInverterCount: 'Wählen Sie einen Wechselrichter aus, um passende Batterien anzuzeigen',
      promptBatteryTitle: 'Wählen Sie zunächst eine Batterie aus',
      promptBatteryText: 'Wählen Sie eine Batteriemarke oder ein Modell aus, verwenden Sie LV/HV oder suchen Sie direkt nach der Modellnummer.',
      promptInverterTitle: 'Wählen Sie zunächst einen Wechselrichter aus',
      promptInverterText: 'Wählen Sie eine Wechselrichtermarke oder ein Modell aus oder suchen Sie direkt nach der Modellnummer.',

      confirmedCombination: 'offiziell bestätigte Kombination',
      confirmedCombinations: 'offiziell bestätigte Kombinationen',
      found: 'gefunden',
      loadMore: 'Weitere Ergebnisse anzeigen',
      remaining: 'verbleibend',

      doubleConfirmed: 'Von beiden Herstellern offiziell bestätigt',
      inverterManufacturerConfirmed: 'Vom Wechselrichterhersteller offiziell bestätigt',
      batteryManufacturerConfirmed: 'Vom Batteriehersteller offiziell bestätigt',
      singleConfirmed: 'Von einem Hersteller offiziell bestätigt',
      doubleConfirmedDescription: 'Von beiden Herstellern bestätigt.',
      inverterManufacturerConfirmedDescription: 'Vom Wechselrichterhersteller ausdrücklich bestätigt.',
      batteryManufacturerConfirmedDescription: 'Vom Batteriehersteller ausdrücklich bestätigt.',
      singleConfirmedDescription: 'In mindestens einer offiziellen Herstellerquelle ausdrücklich bestätigt.',

      min: 'Min.',
      max: 'max.',
      modules: 'Module',
      notAvailable: 'k. A.',
      noModuleLimit: 'In dieser Quelle ist keine Modulgrenze angegeben.',
      noAdditionalCondition: 'In dieser Quelle ist keine zusätzliche Bedingung angegeben.',

      viewBattery: 'Batterie ansehen',
      viewInverter: 'Wechselrichter ansehen',
      technicalConditions: 'Technische Bedingungen und Quellen',
      firmware: 'Firmware',
      moduleConfiguration: 'Modulkonfiguration',
      parallelOperation: 'Parallelbetrieb',
      accessories: 'Zubehör',
      communication: 'Kommunikation:',
      marketCondition: 'Markt-/Anwendungsbedingung:',
      officialSource: 'Offizielle Quelle:',
      sourceFallback: 'Quelle im Rebor-Masterdatensatz registriert.',
      checked: 'Geprüft:',

      batteryBrand: 'Batteriemarke',
      batteryModel: 'Batteriemodell',
      inverterBrand: 'Wechselrichtermarke',
      inverterModel: 'Wechselrichtermodell',
      voltage: 'Spannung',
      searchTerm: 'Suchbegriff',
      removeFilter: 'entfernen'
    }
  };

  const normalize = (value = '') =>
    String(value)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '');

  const escapeHTML = (value = '') =>
    String(value).replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    }[char]));

  const evidenceRank = (level) =>
    level === 'BOTH_MANUFACTURERS_CONFIRMED' ? 2 : 1;

  const getLanguage = () => {
    const htmlLang = (
      document.documentElement.lang ||
      navigator.language ||
      'nl'
    ).toLowerCase();

    if (htmlLang.startsWith('de')) return 'de';
    if (htmlLang.startsWith('en')) return 'en';
    return 'nl';
  };

  class ReborCompatibilityChecker {
    constructor(root) {
      this.root = root;
      this.url = root.dataset.jsonUrl;
      this.pageSize = 24;
      this.visibleCount = this.pageSize;
      this.direction = 'battery';
      this.pairs = [];
      this.filtered = [];

      this.language = getLanguage();
      this.translations = this.getTranslations();

      this.els = {
        form: root.querySelector('[data-rcc-form]'),
        batteryBrand: root.querySelector('[data-rcc-battery-brand]'),
        batteryModel: root.querySelector('[data-rcc-battery-model]'),
        inverterBrand: root.querySelector('[data-rcc-inverter-brand]'),
        inverterModel: root.querySelector('[data-rcc-inverter-model]'),
        batteryFields: [...root.querySelectorAll('[data-rcc-battery-field]')],
        inverterFields: [...root.querySelectorAll('[data-rcc-inverter-field]')],
        query: root.querySelector('[data-rcc-query]'),
        queryLabel: root.querySelector('[data-rcc-query-label]'),
        modeTitle: root.querySelector('[data-rcc-mode-title]'),
        modeDescription: root.querySelector('[data-rcc-mode-description]'),
        sort: root.querySelector('[data-rcc-sort]'),
        alphaOption: root.querySelector('[data-rcc-alpha-option]'),
        count: root.querySelector('[data-rcc-count]'),
        prompt: root.querySelector('[data-rcc-prompt]'),
        results: root.querySelector('[data-rcc-results]'),
        empty: root.querySelector('[data-rcc-empty]'),
        reset: root.querySelector('[data-rcc-reset]'),
        activeFilters: root.querySelector('[data-rcc-active-filters]'),
        loadMore: root.querySelector('[data-rcc-load-more]'),
        loadMoreWrap: root.querySelector('[data-rcc-load-more-wrap]')
      };

      this.bind();
      this.load();
    }

    getTranslations() {
      const fallback =
        DEFAULT_TRANSLATIONS[this.language] ||
        DEFAULT_TRANSLATIONS.nl;

      const translationElement =
        this.root.querySelector('[data-rcc-translations]') ||
        document.querySelector('[data-rcc-translations]');

      if (!translationElement) {
        return fallback;
      }

      try {
        const parsed = JSON.parse(translationElement.textContent);

        if (parsed && typeof parsed === 'object') {
          const languageBlock =
            parsed[this.language] &&
            typeof parsed[this.language] === 'object'
              ? parsed[this.language]
              : parsed;

          return {
            ...fallback,
            ...languageBlock
          };
        }
      } catch (error) {
        console.warn(
          'Rebor compatibility translations could not be parsed',
          error
        );
      }

      return fallback;
    }

    t(key) {
      return (
        this.translations[key] ??
        DEFAULT_TRANSLATIONS[this.language]?.[key] ??
        DEFAULT_TRANSLATIONS.nl[key] ??
        key
      );
    }

    locale() {
      return this.t('locale') || 'nl-NL';
    }

    localizedValue(value, fallback = '') {
      if (value === null || value === undefined) {
        return fallback;
      }

      if (
        typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean'
      ) {
        const text = String(value).trim();
        return text || fallback;
      }

      if (typeof value === 'object' && !Array.isArray(value)) {
        const preferredOrder = [
          this.language,
          'nl',
          'en',
          'de'
        ];

        for (const language of preferredOrder) {
          if (
            Object.prototype.hasOwnProperty.call(value, language) &&
            value[language] !== null &&
            value[language] !== undefined
          ) {
            const text = String(value[language]).trim();

            if (text) {
              return text;
            }
          }
        }

        const firstUsableValue = Object.values(value).find((item) => {
          return (
            item !== null &&
            item !== undefined &&
            typeof item !== 'object' &&
            String(item).trim()
          );
        });

        if (firstUsableValue !== undefined) {
          return String(firstUsableValue).trim();
        }

        return fallback;
      }

      if (Array.isArray(value)) {
        const values = value
          .map((item) => this.localizedValue(item, ''))
          .filter(Boolean);

        return values.length ? values.join(', ') : fallback;
      }

      return fallback;
    }

    conditionText(value) {
      const localized = this.localizedValue(
        value,
        this.t('noAdditionalCondition')
      );

      return escapeHTML(localized);
    }

    unique(values) {
      return [...new Set(values.filter(Boolean))]
        .sort((a, b) =>
          a.localeCompare(
            b,
            this.locale(),
            { sensitivity: 'base' }
          )
        );
    }

    async load() {
      try {
        const response = await fetch(this.url, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const payload = await response.json();

        this.pairs = Array.isArray(payload)
          ? payload
          : (payload.pairs || []);

        this.populateAll();
        this.restoreURLState();
        this.update(false, false);
      } catch (error) {
        console.error(
          'Rebor compatibility data could not be loaded',
          error
        );

        this.els.count.textContent =
          this.t('loadErrorCount');

        this.els.prompt.hidden = true;
        this.els.results.innerHTML = '';
        this.els.empty.hidden = false;

        const emptyTitle =
          this.els.empty.querySelector('h3');

        const emptyText =
          this.els.empty.querySelector('p');

        if (emptyTitle) {
          emptyTitle.textContent =
            this.t('loadErrorTitle');
        }

        if (emptyText) {
          emptyText.textContent =
            this.t('loadErrorText');
        }
      }
    }

    bind() {
      this.root
        .querySelectorAll('[data-rcc-direction]')
        .forEach((button) => {
          button.addEventListener('click', () => {
            const nextDirection =
              button.dataset.rccDirection;

            if (nextDirection === this.direction) {
              return;
            }

            this.direction = nextDirection;
            this.resetInactiveDirectionFields();
            this.applyDirectionUI();

            this.visibleCount = this.pageSize;
            this.update();
          });
        });

      this.els.form.addEventListener(
        'submit',
        (event) => {
          event.preventDefault();
          this.visibleCount = this.pageSize;
          this.update(true);
        }
      );

      [
        this.els.batteryBrand,
        this.els.batteryModel,
        this.els.inverterBrand,
        this.els.inverterModel,
        this.els.sort
      ].forEach((element) => {
        element.addEventListener('change', () => {
          if (element === this.els.batteryBrand) {
            this.populateBatteryModels();
          }

          if (element === this.els.inverterBrand) {
            this.populateInverterModels();
          }

          this.visibleCount = this.pageSize;
          this.update();
        });
      });

      this.root
        .querySelectorAll('[data-rcc-voltage] input')
        .forEach((radio) => {
          radio.addEventListener('change', () => {
            this.visibleCount = this.pageSize;
            this.update();
          });
        });

      let queryTimer;

      this.els.query.addEventListener('input', () => {
        clearTimeout(queryTimer);

        queryTimer = setTimeout(() => {
          this.visibleCount = this.pageSize;
          this.update();
        }, 180);
      });

      this.els.reset.addEventListener('click', () => {
        this.resetCurrentDirection();
        this.visibleCount = this.pageSize;
        this.update();
      });

      this.els.loadMore.addEventListener(
        'click',
        () => {
          this.visibleCount += this.pageSize;
          this.render();
        }
      );

      window.addEventListener('popstate', () => {
        this.restoreURLState();
        this.visibleCount = this.pageSize;
        this.update(false, false);
      });
    }

    applyDirectionUI() {
      const batteryMode =
        this.direction === 'battery';

      this.els.form.dataset.mode =
        this.direction;

      this.els.batteryFields.forEach((field) => {
        field.hidden = !batteryMode;
      });

      this.els.inverterFields.forEach((field) => {
        field.hidden = batteryMode;
      });

      this.root
        .querySelectorAll('[data-rcc-direction]')
        .forEach((button) => {
          const active =
            button.dataset.rccDirection ===
            this.direction;

          button.classList.toggle(
            'is-active',
            active
          );

          button.setAttribute(
            'aria-pressed',
            active ? 'true' : 'false'
          );
        });

      if (batteryMode) {
        this.els.modeTitle.textContent =
          this.t('batteryModeTitle');

        this.els.modeDescription.textContent =
          this.t('batteryModeDescription');

        this.els.queryLabel.textContent =
          this.t('batteryQueryLabel');

        this.els.query.placeholder =
          this.t('batteryQueryPlaceholder');

        this.els.alphaOption.textContent =
          this.t('inverterAlpha');
      } else {
        this.els.modeTitle.textContent =
          this.t('inverterModeTitle');

        this.els.modeDescription.textContent =
          this.t('inverterModeDescription');

        this.els.queryLabel.textContent =
          this.t('inverterQueryLabel');

        this.els.query.placeholder =
          this.t('inverterQueryPlaceholder');

        this.els.alphaOption.textContent =
          this.t('batteryAlpha');
      }
    }

    resetInactiveDirectionFields() {
      if (this.direction === 'battery') {
        this.els.inverterBrand.value = '';
        this.populateInverterModels();
        this.els.inverterModel.value = '';
      } else {
        this.els.batteryBrand.value = '';
        this.populateBatteryModels();
        this.els.batteryModel.value = '';

        const allVoltage =
          this.root.querySelector(
            '[data-rcc-voltage] input[value=""]'
          );

        if (allVoltage) {
          allVoltage.checked = true;
        }
      }

      this.els.query.value = '';
      this.els.sort.value = 'relevance';
    }

    resetCurrentDirection() {
      if (this.direction === 'battery') {
        this.els.batteryBrand.value = '';
        this.populateBatteryModels();
        this.els.batteryModel.value = '';

        const allVoltage =
          this.root.querySelector(
            '[data-rcc-voltage] input[value=""]'
          );

        if (allVoltage) {
          allVoltage.checked = true;
        }
      } else {
        this.els.inverterBrand.value = '';
        this.populateInverterModels();
        this.els.inverterModel.value = '';
      }

      this.els.query.value = '';
      this.els.sort.value = 'relevance';
    }

    populateAll() {
      this.setOptions(
        this.els.batteryBrand,
        this.unique(
          this.pairs.map(
            (pair) => pair.battery_brand
          )
        ),
        this.t('allBrands')
      );

      this.setOptions(
        this.els.inverterBrand,
        this.unique(
          this.pairs.map(
            (pair) => pair.inverter_brand
          )
        ),
        this.t('allBrands')
      );

      this.populateBatteryModels();
      this.populateInverterModels();
    }

    populateBatteryModels() {
      const brand =
        this.els.batteryBrand.value;

      const current =
        this.els.batteryModel.value;

      const values = this.unique(
        this.pairs
          .filter(
            (pair) =>
              !brand ||
              pair.battery_brand === brand
          )
          .map(
            (pair) => pair.battery_model
          )
      );

      this.setOptions(
        this.els.batteryModel,
        values,
        brand
          ? this.t('allModelsBrand')
          : this.t('allModels')
      );

      if (values.includes(current)) {
        this.els.batteryModel.value =
          current;
      }
    }

    populateInverterModels() {
      const brand =
        this.els.inverterBrand.value;

      const current =
        this.els.inverterModel.value;

      const values = this.unique(
        this.pairs
          .filter(
            (pair) =>
              !brand ||
              pair.inverter_brand === brand
          )
          .map(
            (pair) => pair.inverter_model
          )
      );

      this.setOptions(
        this.els.inverterModel,
        values,
        brand
          ? this.t('allModelsBrand')
          : this.t('allModels')
      );

      if (values.includes(current)) {
        this.els.inverterModel.value =
          current;
      }
    }

    setOptions(
      select,
      values,
      emptyLabel
    ) {
      select.innerHTML =
        `<option value="">${escapeHTML(emptyLabel)}</option>` +
        values
          .map(
            (value) =>
              `<option value="${escapeHTML(value)}">${escapeHTML(value)}</option>`
          )
          .join('');
    }

    state() {
      return {
        direction: this.direction,
        batteryBrand:
          this.els.batteryBrand.value,
        batteryModel:
          this.els.batteryModel.value,
        inverterBrand:
          this.els.inverterBrand.value,
        inverterModel:
          this.els.inverterModel.value,
        voltage:
          this.root.querySelector(
            '[data-rcc-voltage] input:checked'
          )?.value || '',
        query:
          this.els.query.value.trim(),
        sort:
          this.els.sort.value
      };
    }

    hasSearchIntent(
      state = this.state()
    ) {
      if (
        state.direction === 'battery'
      ) {
        return Boolean(
          state.batteryBrand ||
          state.batteryModel ||
          state.voltage ||
          state.query
        );
      }

      return Boolean(
        state.inverterBrand ||
        state.inverterModel ||
        state.query
      );
    }

    filterPairs() {
      const state = this.state();
      const q = normalize(state.query);

      let pairs =
        this.pairs.filter((pair) => {
          if (
            state.direction === 'battery'
          ) {
            if (
              state.batteryBrand &&
              pair.battery_brand !==
                state.batteryBrand
            ) {
              return false;
            }

            if (
              state.batteryModel &&
              pair.battery_model !==
                state.batteryModel
            ) {
              return false;
            }

            if (
              state.voltage &&
              pair.battery_voltage_class !==
                state.voltage
            ) {
              return false;
            }

            if (q) {
              const batteryHaystack =
                normalize([
                  pair.battery_brand,
                  pair.battery_family,
                  pair.battery_model
                ].join(' '));

              if (
                !batteryHaystack.includes(q)
              ) {
                return false;
              }
            }
          } else {
            if (
              state.inverterBrand &&
              pair.inverter_brand !==
                state.inverterBrand
            ) {
              return false;
            }

            if (
              state.inverterModel &&
              pair.inverter_model !==
                state.inverterModel
            ) {
              return false;
            }

            if (q) {
              const inverterHaystack =
                normalize([
                  pair.inverter_brand,
                  pair.inverter_family,
                  pair.inverter_model
                ].join(' '));

              if (
                !inverterHaystack.includes(q)
              ) {
                return false;
              }
            }
          }

          return true;
        });

      pairs.sort((a, b) => {
        if (
          state.sort === 'evidence'
        ) {
          return (
            evidenceRank(
              b.evidence_level
            ) -
              evidenceRank(
                a.evidence_level
              ) ||
            this.compareTarget(a, b)
          );
        }

        if (
          state.sort === 'alpha'
        ) {
          return this.compareTarget(
            a,
            b
          );
        }

        return (
          evidenceRank(
            b.evidence_level
          ) -
            evidenceRank(
              a.evidence_level
            ) ||
          this.compareTarget(a, b)
        );
      });

      return pairs;
    }

    compareTarget(a, b) {
      if (
        this.direction === 'battery'
      ) {
        return `${a.inverter_brand} ${a.inverter_model}`
          .localeCompare(
            `${b.inverter_brand} ${b.inverter_model}`,
            this.locale(),
            { sensitivity: 'base' }
          );
      }

      return `${a.battery_brand} ${a.battery_model}`
        .localeCompare(
          `${b.battery_brand} ${b.battery_model}`,
          this.locale(),
          { sensitivity: 'base' }
        );
    }

    update(
      track = false,
      syncURL = true
    ) {
      if (!this.pairs.length) return;

      const state = this.state();

      if (
        !this.hasSearchIntent(state)
      ) {
        this.filtered = [];
        this.renderPrompt();
        this.renderActiveFilters();

        if (syncURL) {
          this.syncURL();
        }

        return;
      }

      this.filtered =
        this.filterPairs();

      this.render();
      this.renderActiveFilters();

      if (syncURL) {
        this.syncURL();
      }

      if (track) {
        this.track();
      }
    }

    renderPrompt() {
      const batteryMode =
        this.direction === 'battery';

      this.els.results.innerHTML = '';
      this.els.empty.hidden = true;
      this.els.loadMoreWrap.hidden =
        true;
      this.els.prompt.hidden = false;

      this.els.count.textContent =
        batteryMode
          ? this.t(
              'promptBatteryCount'
            )
          : this.t(
              'promptInverterCount'
            );

      const strong =
        this.els.prompt.querySelector(
          'strong'
        );

      const span =
        this.els.prompt.querySelector(
          'span'
        );

      if (batteryMode) {
        strong.textContent =
          this.t(
            'promptBatteryTitle'
          );

        span.textContent =
          this.t(
            'promptBatteryText'
          );
      } else {
        strong.textContent =
          this.t(
            'promptInverterTitle'
          );

        span.textContent =
          this.t(
            'promptInverterText'
          );
      }
    }

    render() {
      const count =
        this.filtered.length;

      this.els.prompt.hidden = true;
      this.els.empty.hidden =
        count !== 0;

      const combinationText =
        count === 1
          ? this.t(
              'confirmedCombination'
            )
          : this.t(
              'confirmedCombinations'
            );

      this.els.count.textContent =
        `${count} ${combinationText} ${this.t('found')}`;

      const visible =
        this.filtered.slice(
          0,
          this.visibleCount
        );

      this.els.results.innerHTML =
        visible
          .map(
            (pair) =>
              this.card(pair)
          )
          .join('');

      const hasMore =
        count > this.visibleCount;

      this.els.loadMoreWrap.hidden =
        !hasMore;

      if (hasMore) {
        const remaining =
          count -
          this.visibleCount;

        this.els.loadMore.textContent =
          `${this.t('loadMore')} (${remaining} ${this.t('remaining')})`;
      }
    }

    evidenceStatus(pair) {
      if (
        pair.evidence_level ===
        'BOTH_MANUFACTURERS_CONFIRMED'
      ) {
        return {
          className: 'double',
          text: this.t(
            'doubleConfirmed'
          ),
          description: this.t(
            'doubleConfirmedDescription'
          ),
          icon: '&#10003;&#10003; '
        };
      }

      if (
        pair.evidence_level ===
        'INVERTER_MANUFACTURER_CONFIRMED'
      ) {
        return {
          className: 'single',
          text: this.t(
            'inverterManufacturerConfirmed'
          ),
          description: this.t(
            'inverterManufacturerConfirmedDescription'
          ),
          icon: '&#10003; '
        };
      }

      if (
        pair.evidence_level ===
        'BATTERY_MANUFACTURER_CONFIRMED'
      ) {
        return {
          className: 'single',
          text: this.t(
            'batteryManufacturerConfirmed'
          ),
          description: this.t(
            'batteryManufacturerConfirmedDescription'
          ),
          icon: '&#10003; '
        };
      }

      const localizedStatus =
        this.localizedValue(
          pair.display_status,
          this.t('singleConfirmed')
        );

      return {
        className: 'single',
        text: localizedStatus,
        description: this.t(
          'singleConfirmedDescription'
        ),
        icon: '&#10003; '
      };
    }

    card(pair) {
      const status =
        this.evidenceStatus(pair);

      const minValue =
        pair.min_modules ||
        this.t('notAvailable');

      const maxValue =
        pair.max_modules ||
        this.t('notAvailable');

      const minMax =
        pair.min_modules ||
        pair.max_modules
          ? `${this.t('min')} ${escapeHTML(minValue)} / ${this.t('max')} ${escapeHTML(maxValue)} ${this.t('modules')}`
          : escapeHTML(
              this.t(
                'noModuleLimit'
              )
            );

      const languagePrefix =
  this.language === 'de'
    ? '/de'
    : this.language === 'en'
      ? '/en'
      : '';

const batteryURL =
  pair.battery_handle
    ? `${languagePrefix}/products/${encodeURIComponent(pair.battery_handle)}`
    : '';

const inverterURL =
  pair.inverter_handle
    ? `${languagePrefix}/products/${encodeURIComponent(pair.inverter_handle)}`
    : '';

      const firmwareConditions =
        this.conditionText(
          pair.firmware_conditions
        );

      const parallelConditions =
        this.conditionText(
          pair.parallel_conditions
        );

      const accessoryConditions =
        this.conditionText(
          pair.accessory_combiner_conditions
        );

      const marketRestrictions =
        this.localizedValue(
          pair.market_restrictions,
          ''
        );

      const sourceSummary =
        this.localizedValue(
          pair.source_summary,
          this.t('sourceFallback')
        );

      return `
        <article class="rcc-card" data-pair-id="${escapeHTML(pair.pair_id)}">
          <div class="rcc-card__summary">
            <div class="rcc-card__product">
              <span class="rcc-card__brand">${escapeHTML(pair.battery_brand)}</span>
              <span class="rcc-card__model">${escapeHTML(pair.battery_model)}</span>

              <div class="rcc-card__meta">
                <span>${escapeHTML(pair.battery_family || '')}</span>
                <span>${escapeHTML(pair.battery_voltage_class || '')}</span>
              </div>

              ${
                batteryURL
                  ? `<a class="rcc-card__link" href="${batteryURL}">${escapeHTML(this.t('viewBattery'))} &rarr;</a>`
                  : ''
              }
            </div>

            <div class="rcc-card__arrow" aria-hidden="true">&#8596;</div>

            <div class="rcc-card__product">
              <span class="rcc-card__brand">${escapeHTML(pair.inverter_brand)}</span>
              <span class="rcc-card__model">${escapeHTML(pair.inverter_model)}</span>

              <div class="rcc-card__meta">
                <span>${escapeHTML(pair.inverter_family || '')}</span>
                <span>${escapeHTML(pair.inverter_phase || '')}</span>
              </div>

              ${
                inverterURL
                  ? `<a class="rcc-card__link" href="${inverterURL}">${escapeHTML(this.t('viewInverter'))} &rarr;</a>`
                  : ''
              }
            </div>

            <div class="rcc-card__status rcc-card__status--${status.className}">
              <strong>
                ${status.icon}${escapeHTML(status.text)}
              </strong>

              <small>
                ${escapeHTML(status.description)}
              </small>
            </div>
          </div>

          <details>
            <summary>${escapeHTML(this.t('technicalConditions'))}</summary>

            <div class="rcc-card__details">
              <div class="rcc-card__conditions">

                <section class="rcc-condition">
                  <h4>${escapeHTML(this.t('firmware'))}</h4>
                  <p>${firmwareConditions}</p>
                </section>

                <section class="rcc-condition">
                  <h4>${escapeHTML(this.t('moduleConfiguration'))}</h4>
                  <p>${minMax}</p>
                </section>

                <section class="rcc-condition">
                  <h4>${escapeHTML(this.t('parallelOperation'))}</h4>
                  <p>${parallelConditions}</p>
                </section>

                <section class="rcc-condition">
                  <h4>${escapeHTML(this.t('accessories'))}</h4>
                  <p>${accessoryConditions}</p>
                </section>

              </div>

              ${
                pair.communication_protocol
                  ? `
                    <div class="rcc-card__source">
                      <strong>${escapeHTML(this.t('communication'))}</strong>
                      ${escapeHTML(pair.communication_protocol)}
                    </div>
                  `
                  : ''
              }

              ${
                marketRestrictions
                  ? `
                    <div class="rcc-card__source">
                      <strong>${escapeHTML(this.t('marketCondition'))}</strong>
                      ${escapeHTML(marketRestrictions)}
                    </div>
                  `
                  : ''
              }

              <div class="rcc-card__source">
                <strong>${escapeHTML(this.t('officialSource'))}</strong>
                ${escapeHTML(sourceSummary)}

                ${
                  pair.source_checked_date
                    ? `<br><strong>${escapeHTML(this.t('checked'))}</strong> ${escapeHTML(pair.source_checked_date)}`
                    : ''
                }
              </div>
            </div>
          </details>
        </article>
      `;
    }

    renderActiveFilters() {
      const state = this.state();
      let chips = [];

      if (
        state.direction === 'battery'
      ) {
        chips = [
          [
            this.t('batteryBrand'),
            state.batteryBrand,
            () => {
              this.els.batteryBrand.value =
                '';

              this.populateBatteryModels();
            }
          ],
          [
            this.t('batteryModel'),
            state.batteryModel,
            () => {
              this.els.batteryModel.value =
                '';
            }
          ],
          [
            this.t('voltage'),
            state.voltage,
            () => {
              const allVoltage =
                this.root.querySelector(
                  '[data-rcc-voltage] input[value=""]'
                );

              if (allVoltage) {
                allVoltage.checked =
                  true;
              }
            }
          ],
          [
            this.t('searchTerm'),
            state.query,
            () => {
              this.els.query.value =
                '';
            }
          ]
        ];
      } else {
        chips = [
          [
            this.t('inverterBrand'),
            state.inverterBrand,
            () => {
              this.els.inverterBrand.value =
                '';

              this.populateInverterModels();
            }
          ],
          [
            this.t('inverterModel'),
            state.inverterModel,
            () => {
              this.els.inverterModel.value =
                '';
            }
          ],
          [
            this.t('searchTerm'),
            state.query,
            () => {
              this.els.query.value =
                '';
            }
          ]
        ];
      }

      chips =
        chips.filter(
          ([, value]) => value
        );

      this.els.activeFilters.innerHTML =
        '';

      chips.forEach(
        ([label, value, clear]) => {
          const chip =
            document.createElement(
              'span'
            );

          chip.className =
            'rcc__chip';

          const labelSpan =
            document.createElement(
              'span'
            );

          labelSpan.textContent =
            `${label}: `;

          const strong =
            document.createElement(
              'strong'
            );

          strong.textContent =
            value;

          labelSpan.appendChild(
            strong
          );

          chip.appendChild(
            labelSpan
          );

          const button =
            document.createElement(
              'button'
            );

          button.type =
            'button';

          button.setAttribute(
            'aria-label',
            `${label} ${this.t('removeFilter')}`
          );

          button.textContent =
            '×';

          button.addEventListener(
            'click',
            () => {
              clear();
              this.visibleCount =
                this.pageSize;
              this.update();
            }
          );

          chip.appendChild(
            button
          );

          this.els.activeFilters.appendChild(
            chip
          );
        }
      );
    }

    syncURL() {
      const state =
        this.state();

      const url =
        new URL(
          window.location.href
        );

      [
        'bb',
        'bm',
        'ib',
        'im',
        'v',
        'q',
        'sort',
        'dir'
      ].forEach((key) => {
        url.searchParams.delete(
          key
        );
      });

      if (
        state.direction !== 'battery'
      ) {
        url.searchParams.set(
          'dir',
          state.direction
        );
      }

      if (
        state.direction === 'battery'
      ) {
        if (state.batteryBrand) {
          url.searchParams.set(
            'bb',
            state.batteryBrand
          );
        }

        if (state.batteryModel) {
          url.searchParams.set(
            'bm',
            state.batteryModel
          );
        }

        if (state.voltage) {
          url.searchParams.set(
            'v',
            state.voltage
          );
        }
      } else {
        if (state.inverterBrand) {
          url.searchParams.set(
            'ib',
            state.inverterBrand
          );
        }

        if (state.inverterModel) {
          url.searchParams.set(
            'im',
            state.inverterModel
          );
        }
      }

      if (state.query) {
        url.searchParams.set(
          'q',
          state.query
        );
      }

      if (
        state.sort !== 'relevance'
      ) {
        url.searchParams.set(
          'sort',
          state.sort
        );
      }

      history.replaceState(
        null,
        '',
        `${url.pathname}${url.search}${url.hash}`
      );
    }

    restoreURLState() {
      const params =
        new URLSearchParams(
          window.location.search
        );

      const direction =
        params.get('dir') ===
        'inverter'
          ? 'inverter'
          : 'battery';

      this.direction =
        direction;

      this.applyDirectionUI();

      if (
        direction === 'battery'
      ) {
        const batteryBrand =
          params.get('bb') || '';

        if (
          [
            ...this.els.batteryBrand.options
          ].some(
            (option) =>
              option.value ===
              batteryBrand
          )
        ) {
          this.els.batteryBrand.value =
            batteryBrand;
        }

        this.populateBatteryModels();

        const batteryModel =
          params.get('bm') || '';

        if (
          [
            ...this.els.batteryModel.options
          ].some(
            (option) =>
              option.value ===
              batteryModel
          )
        ) {
          this.els.batteryModel.value =
            batteryModel;
        }

        const voltage =
          params.get('v') || '';

        const voltageRadio =
          [
            ...this.root.querySelectorAll(
              '[data-rcc-voltage] input'
            )
          ].find(
            (radio) =>
              radio.value === voltage
          );

        if (voltageRadio) {
          voltageRadio.checked =
            true;
        }

        this.els.inverterBrand.value =
          '';

        this.populateInverterModels();

        this.els.inverterModel.value =
          '';
      } else {
        const inverterBrand =
          params.get('ib') || '';

        if (
          [
            ...this.els.inverterBrand.options
          ].some(
            (option) =>
              option.value ===
              inverterBrand
          )
        ) {
          this.els.inverterBrand.value =
            inverterBrand;
        }

        this.populateInverterModels();

        const inverterModel =
          params.get('im') || '';

        if (
          [
            ...this.els.inverterModel.options
          ].some(
            (option) =>
              option.value ===
              inverterModel
          )
        ) {
          this.els.inverterModel.value =
            inverterModel;
        }

        this.els.batteryBrand.value =
          '';

        this.populateBatteryModels();

        this.els.batteryModel.value =
          '';

        const allVoltage =
          this.root.querySelector(
            '[data-rcc-voltage] input[value=""]'
          );

        if (allVoltage) {
          allVoltage.checked =
            true;
        }
      }

      this.els.query.value =
        params.get('q') || '';

      const sort =
        params.get('sort') ||
        'relevance';

      if (
        [
          ...this.els.sort.options
        ].some(
          (option) =>
            option.value === sort
        )
      ) {
        this.els.sort.value =
          sort;
      } else {
        this.els.sort.value =
          'relevance';
      }
    }

    track() {
      const detail = {
        event:
          'rebor_compatibility_search',
        language:
          this.language,
        ...this.state(),
        resultCount:
          this.filtered.length
      };

      window.dispatchEvent(
        new CustomEvent(
          'rebor:compatibility-search',
          { detail }
        )
      );

      if (
        Array.isArray(
          window.dataLayer
        )
      ) {
        window.dataLayer.push(
          detail
        );
      }
    }
  }

  roots.forEach((root) => {
    new ReborCompatibilityChecker(
      root
    );
  });
})();